import { Box, Button, Chip, Grid, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  chip?: string | JSX.Element;
  snippet: string | JSX.Element;
  title: string | JSX.Element;
  description: string | JSX.Element;
  buttonText?: string;
  handleClick?: () => void;
}
const StyledBanner = ({
  chip,
  snippet,
  title,
  description,
  buttonText,
  handleClick,
}: Props) => {
  return (
    <Grid container sx={styles.banner} gap={1}>
      <Grid item xs md>
        {chip && <Chip label={chip} size="small" sx={styles.chip} />}
        <Typography
          sx={{ textTransform: "uppercase", color: "black", fontWeight: 600 }}
          gutterBottom
        >
          <Box component="span" sx={{ color: "purple.dark", fontWeight: 700 }}>
            {snippet}
          </Box>{" "}
          {title}
        </Typography>

        <Typography>{description}</Typography>
      </Grid>

      {buttonText && handleClick && (
        <Grid item xs={12} md="auto">
          <Button sx={styles.button} variant="outlined" onClick={handleClick}>
            {buttonText}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default StyledBanner;
